import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { DialogService, DynamicDialogComponent, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { SvgIconComponent } from 'angular-svg-icon';
import { HttpError } from '@app/core/interceptors/error-interceptor/classes/http-error';
import { InfoMessageComponent } from '@app/shared/components/info-message/components/info-message/info-message.component';
import { InfoMessageStatus } from '@app/shared/components/info-message/enums/info-message-type.enum';
import { TranslateDirective, TranslatePipe, _ } from '@ngx-translate/core';
import { BaseErrorStatus } from '@app/api/enums/base-error-status.enum';

@Component({
  selector: 'gc-dialog-error-intercepted',
  templateUrl: './dialog-error-intercepted.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, SvgIconComponent, InfoMessageComponent, TranslateDirective, TranslatePipe],
})
export class DialogErrorInterceptedComponent implements OnInit, OnDestroy {
  public ref: DynamicDialogRef = inject(DynamicDialogRef);
  public dialogService: DialogService = inject(DialogService);

  public instance: DynamicDialogComponent | undefined;

  public data: HttpError | undefined;

  public InfoMessageStatus = InfoMessageStatus;
  public BaseErrorStatus = BaseErrorStatus;

  public readonly closeButtonLabel: string = _(`@@shared-got-it__text`);
  public readonly malformedInputDataMessage: string = _(`@@dialog-error-intercepted__malformed-input-data-message`);

  public get malformedInputDataParams(): { parameterName: string } {
    const match = this.data?.message?.match(/['"]([^'"]+)['"]/);
    return { parameterName: match?.[1] || 'unknown' };
  }

  constructor() {
    this.instance = this.dialogService.getInstance(this.ref);
  }

  ngOnInit() {
    if (this.instance && this.instance.data) {
      this.data = this.instance.data as HttpError;
    }
  }

  close() {
    this.ref.close();
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }
}
